import { TOtpStore, TValidOtpResponse } from '~/store/otp-verification/types.ts';
import { PayloadAction } from '@reduxjs/toolkit';

export const ValidOtpFulfilled = (state: TOtpStore, action: PayloadAction<TValidOtpResponse>) => {
  state.verificationToken = action.payload.verificationToken;

  state.loading = false;
  state.error = null;
  state.status = '';
};

export const ValidOtpPending = (state: TOtpStore) => {
  state.loading = true;
};
